import { Component,OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-smartsheet',
  templateUrl: './smartsheet.component.html',
  styleUrls: ['./smartsheet.component.css']
})
export class SmartsheetComponent implements OnInit {

  KisshtHtml: SafeHtml | undefined;
  constructor(private http:HttpClient,
    private sanitizer:DomSanitizer) { }
 url ='https://app.smartsheet.com/sheets/M9CQ3QM8h2H3xqW4HVVJJ23CVv2rWFQ5cp4vc971';
  ngOnInit(): void {



    this.http.get(this.url,{responseType:'text'}).subscribe(res=>{
      this.KisshtHtml = this.sanitizer.bypassSecurityTrustHtml(res);
    })
  }

}
